import {useTranslation} from 'react-i18next';
import Input from '../../../../../component/input/Input';
import Close from '../../../../../component/close/Close';
import * as css from './Committees.css';

interface CommitteeRowProps {
    index: number;
    onRemove: (index: number) => void;
    onEdit: () => void;
}

function CommitteeRow({index, onRemove, onEdit}: CommitteeRowProps) {
    const {t} = useTranslation('ticket');

    return (
        <css.committeeRow>
                <Close onClick={() => onRemove(index)} className="" />
            <Input
                name={`committees.${index}.title`}
                text={t('committee')}
                disabled={true}
                icon={false}
                events={{onClick: onEdit}}
                className=""
                forwardRef={null}
            />
            <Input
                name={`committees.${index}.ticketToken`}
                text={t('ticketToken')}
                disabled={true}
                icon={false}
                events={{onClick: onEdit}}
                className=""
                forwardRef={null}
            />
        </css.committeeRow>
    );
}

export default CommitteeRow;
